import React from 'react'
import { t } from 'ttag'
import { connect } from 'react-redux'
import { actions as formActions } from 'react-redux-form'
import { Link } from 'react-router-dom'

import JournalInlineEdit from './JournalInlineEdit'

import {
  createJournalEntryFor,
  INLINE_EDIT_TYPE_JOURNAL_ENTRY,
  loadJournals,
  selectJournalEntryForEdit
} from '../../actions/journals'
import Field from '../form/Field'
import Form from '../form/Form'
import ActionButton from '../ActionButton'
import * as v from '../../components/form/validations'

class PopupJournal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      renderKey: 1
    }
  }

  componentDidMount() {
    this.props.dispatch(loadJournals()).then(j => {
      // console.log(j)
      if (j.length === 1) {
        this.props.updateSelectedJournal(j[0])
      }
    })
  }

  render() {
    const {
      journals,
      journalData,
      objectType,
      objectId,
      objectTitle,
      onCreateJournalEntryFor,
      entryPopupRequest,
      journalListing
    } = this.props
    //console.log(this.props)
    const filtered = (journalData || [])
      .map(p => {
        const filteredEntries = (p.entries || []).filter(
          f =>
            f.flag &&
            f.flag.referencedId === this.props.objectId &&
            f.flag.referencedType === this.props.objectType
        )

        return {
          ...p,
          entries: filteredEntries
        }
      })
      .filter(p => p.entries.length >= 1)

    //  console.log(this.props)

    const sortListing = inp => {
      return inp.sort((a, b) => {
        return a.id - b.id
      })
    }

    return (
      <div>
        <ul className="popup-journal-list">
          {!filtered.length > 0 ? (
            <li>
              <span className="journallink">{t`No Journals Found`}</span>
            </li>
          ) : (
            (filtered || []).map(p => (
              <li key={p.id}>
                <Link className="journallink" to={`/careerhub/journal/${p.id}`}>
                  {p.name}
                </Link>
                <ul>
                  {(sortListing(p.entries) || []).map(j => {
                    const rowEditing =
                      this.props.inlineEditing.id == j.id &&
                      this.props.inlineEditing.type === INLINE_EDIT_TYPE_JOURNAL_ENTRY

                    return (
                      <li key={j.id} className="clear">
                        <div className="col-xs-2">
                          {new Date(j.lastModified).toLocaleDateString()}
                        </div>
                        <div className="col-xs-10">
                          <a
                            onClick={() => {
                              this.props.selectForEdit(j)
                            }}
                            style={{ display: rowEditing ? 'none' : 'initial' }}
                            className="table-action edit pull-right"
                            href="javascript:void(0)">
                            <span>e</span>
                          </a>
                          <JournalInlineEdit
                            selectedJournalEntry={j}
                            isEditing={rowEditing}
                            entryEditRequest={this.props.entryEditRequest}
                            dispatch={this.props.dispatch}
                            cancelEdit={this.props.cancelEdit}
                          />
                        </div>
                        <br className="clear" />
                      </li>
                    )
                  })}
                </ul>
              </li>
            ))
          )}
        </ul>
        <Form
          model="journals.popupEntryForm"
          onSubmit={form => {
            onCreateJournalEntryFor(form, objectId, objectType, objectTitle).then(() => {
              this.setState({ ...this.state, renderKey: this.state.renderKey + 1 })
              console.log(this.state)
            })
          }}>
          {form => (
            <div>
              <Field
                model={`journals.popupEntryForm.journalId`}
                form={form}
                label={t`Journal`}
                required={true}
                type="SimpleSelect"
                options={journalListing}
                createFromValue={value => {
                  return {
                    label: value.name,
                    value
                  }
                }}
                createFromSearch={(options, value) => {
                  if (v.stringDefined(value)) {
                    return {
                      label: value,
                      value: { type: 'UNKNOWN', name: value }
                    }
                  }
                }}></Field>
              <Field
                model="journals.popupEntryForm.entry"
                form={form}
                renderKey={this.state.renderKey}
                type="tinymce"
                label={t`Enter a new entry in the box below`}
                required={true}
              />
              <div style={{ margin: '20px 0' }}>
                <ActionButton
                  request={entryPopupRequest}
                  success={null}
                  type="submit"
                  className="btn btn-success">
                  {' '}
                  {t`Create Journal Entry`}{' '}
                </ActionButton>
              </div>
            </div>
          )}
        </Form>
      </div>
    )
  }
}

export default connect(
  state => {
    return {
      entryPopupRequest: state.journals.entryPopupRequest,
      entrySaveRequest: state.journals.entrySaveRequest,
      entryEditRequest: state.journals.entryEditRequest,
      journalData: state.journals.data.journals,
      inlineEditing: state.journals.data.inlineEditing,
      journalListing: (state.journals.data.journals || []).map(j => {
        return {
          label: j.name,
          uid: j.id,
          value: {
            id: j.id,
            name: j.name
          }
        }
      })
    }
  },
  dispatch => ({
    onCreateJournalEntryFor: (form, objectId, objectType, objectTitle) => {
      return dispatch(
        createJournalEntryFor(form, objectId, objectType, objectTitle)
      ).then(() => {
        dispatch(formActions.change('journals.popupEntryForm.entry', ''))

        return Promise.resolve(true)
      })
    },
    updateSelectedJournal: j => {
      dispatch(formActions.change('journals.popupEntryForm.journalId', j))
    },
    selectForEdit: j => {
      dispatch(selectJournalEntryForEdit(j))
    },
    cancelEdit: () => {
      dispatch(selectJournalEntryForEdit({ id: null }))
    },
    dispatch
  })
)(PopupJournal)
